/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CalendarCheckmarkIconOutline = createIcon({
  displayName: 'CalendarCheckmarkIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M18.383 8h1.061c.86 0 1.556.696 1.556 1.556v9.889c0 .859-.696 1.555-1.556 1.555h-10.888c-.86 0-1.556-.696-1.556-1.556v-1.444" />
        <path d="M4.001 18h11.312c.669 0 1.293-.334 1.664-.891l.734-1.102c.438-.657.672-1.429.672-2.219v-7.788c0-1.105-.895-2-2-2h-10c-1.105 0-2 .895-2 2v7.056c0 .621-.145 1.233-.422 1.789l-.854 1.708c-.333.665.151 1.447.894 1.447Z" />
        <path d="M13.651 9.593l-2.813 2.813 -1.688-1.687" />
        <path d="M8.38 3v2" />
        <path d="M14.38 3v2" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24h-24v-24Z" />
    </>
  ),
})

const CalendarCheckmarkIconFilled = createIcon({
  displayName: 'CalendarCheckmarkIconFilled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <Box
          as="path"
          fill="primary.500"
          d="M18.383 8h1.061c.86 0 1.556.696 1.556 1.556v9.889c0 .859-.696 1.555-1.556 1.555h-10.888c-.86 0-1.556-.696-1.556-1.556v-1.444"
        />
        <path
          fill="white"
          d="M4.001 18h11.312c.669 0 1.293-.334 1.664-.891l.734-1.102c.438-.657.672-1.429.672-2.219v-7.788c0-1.105-.895-2-2-2h-10c-1.105 0-2 .895-2 2v7.056c0 .621-.145 1.233-.422 1.789l-.854 1.708c-.333.665.151 1.447.894 1.447Z"
        />
        <Box as="path" strokeWidth="2.5" stroke="primary.500" d="M13.651 9.593l-2.813 2.813 -1.688-1.687" />
        <path d="M8.38 3v2" />
        <path d="M14.38 3v2" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24h-24v-24Z" />
    </>
  ),
})

const CalendarCheckmark: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'filled':
      return <CustomIcon as={CalendarCheckmarkIconFilled} {...props} />
    default:
      return <CustomIcon as={CalendarCheckmarkIconOutline} {...props} />
  }
}

export default memo(CalendarCheckmark)
